export const detectUserAgentIsRobot = (userAgent): boolean => {
  if(userAgent.includes('Speed Insights') || userAgent.includes('Chrome-Lighthouse')) {
    return true
  }

  return false
}
